var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footerArea"}},[_c('footer',{staticClass:"pc_footer"},[_c('p',[_vm._v("Copyright © Lawson, Inc. All Rights Reserved.")])])])}]

export { render, staticRenderFns }